const url = {
    path: "https://websitebackend3.infoxtechnologies.com"
}
export default url